import fetch from './../_node_modules/node-fetch/src/index.js';
import * as z from "zod";
import { decode } from "./decode.js";
const NPM_REGISTRY_ABBREVIATED_METADATA_ACCEPT_HEADER = "application/vnd.npm.install-v1+json; q=1.0, application/json; q=0.8, */*";
const NPMRegistryPackageMetadataSchema = z.object({
  versions: z.record(z.string(), z.unknown())
});
const fetchNPMPackageVersions = async (args) => {
  const res = await fetch(`https://registry.npmjs.org/${args.packageName}`, {
    headers: {
      Accept: NPM_REGISTRY_ABBREVIATED_METADATA_ACCEPT_HEADER
    }
  });
  const json = await res.json();
  const { value, error } = decode(NPMRegistryPackageMetadataSchema, json);
  if (error) {
    throw new Error(`Invalid NPM registry response.`, { cause: error });
  }
  return Object.keys(value.versions);
};
export {
  fetchNPMPackageVersions
};
//# sourceMappingURL=fetchNPMPackageVersions.js.map
